import baseapi from '../services/baseapi';
import keycloak from './keycloak';

export const handleLogout = async () => {
  try {
    const response = await baseapi.post('/logout');
    if (response.data.status) {
      localStorage.clear();
      keycloak.logout({ redirectUri: window.location.origin });
    } else {
      keycloak.logout({ redirectUri: window.location.origin });
    }
  } catch (error) {
     keycloak.logout({ redirectUri: window.location.origin });
  }
};

